import { CHECK_CLIP_AND_DELIVER } from 'root/src/shared/descriptions/endpoints/endpointIds'

import checkClipAndDeliverPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/checkClipAndDeliverPayloadSchema'

export default {
	[CHECK_CLIP_AND_DELIVER]: {
		payloadSchema: checkClipAndDeliverPayloadSchema,
	},
}
